import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './feedbackDialog.component.html',
    styleUrls: ['./modal.css'],
  	standalone: false
})
export class FeedbackDialogComponent {

	level: string;
    title: string;
    message: string;

    constructor(public dialogRef: MatDialogRef<FeedbackDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
		this.level = data.level;
        this.message = data.message;
        this.title = data.title;
    }

    close(): void {
        this.dialogRef.close();
    }

}
